module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.device != 'xs') ? _c('div', [_vm._v("\r\n  ©" + _vm._s(_vm.toDate(null, true, 'YYYY')) + " Todos os Direitos Reservados a "), _c('b', [_vm._v(_vm._s(_vm.cliente.logged.nome))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-997adfc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/menu/footer.v2.vue
// module id = 1525
// module chunks = 45